<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { fetchAccountProductsConfig } from '@/api/accountsClient'

const props = defineProps<{ productId: string | number }>()

const route = useRoute()

const displayName = ref<string>('')
const productIdSimple = ref<string>('')

const loadName = async () => {
  try {
    const data = await fetchAccountProductsConfig(String(props.productId))
    console.log('data', data)
    displayName.value =
      data?.commonData?.productFriendlyName ||
      data?.config?.productFriendlyName ||
      data?.productFriendlyName ||
      data?.config?.productName ||
      data?.productName ||
      data?.product ||
      String(props.productId)

    // Extract simple product ID (last segment of path)
    productIdSimple.value = String(props.productId).split('/').pop() || String(props.productId)
  } catch {
    displayName.value = String(props.productId)
    productIdSimple.value = String(props.productId).split('/').pop() || String(props.productId)
  }
}

onMounted(loadName)
watch(() => route.fullPath, loadName)
watch(() => props.productId, loadName)
</script>

<template>
  <v-toolbar
    color="primary"
    density="comfortable"
    flat
    class="product-header pa-1"
    data-testid="product-header"
  >
    <div class="d-flex align-center pl-2" style="gap: 12px">
      <div class="text-h5 font-weight-medium" data-testid="product-friendly-name">
        {{ displayName }}
      </div>
      <v-chip size="small" variant="flat" class="product-id-chip" data-testid="product-id-chip">
        {{ productIdSimple }}
      </v-chip>
    </div>
  </v-toolbar>
</template>

<style scoped>
.product-header {
  position: sticky;
  top: 0;
  z-index: 5;
}
@media (max-width: 960px) {
  .product-header {
    top: 0;
  }
}

.product-id-chip {
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.95) !important;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
</style>
